import React from 'react';
import dayjs from 'dayjs';
import {Box,FormHelperText,IconButton,Stack,Tooltip} from '@mui/material';
import {Add as AddIcon,Clear as ClearIcon} from '@mui/icons-material';
import {TimeField} from '@mui/x-date-pickers';
import {daypartPairs,getDaypartsError} from 'utils/dayparts';

export default function DaypartsEditor({value,onChange,onClear,labels=false,disabled=false,labelPrefix='投放时段'}) {
  const pairs=daypartPairs(value);
  const error=getDaypartsError(value);
  const change=(index,time)=>onChange(value.map((old,i)=>i===index?time:old));
  const add=()=>{
    const end=value.at(-1);
    const next=end?.isValid() && end.format('HH:mm')<'23:59';
    onChange([...value,next?end:null,next?dayjs('2022-02-22 23:59'):null]);
  };
  return (
    <Box>
      <Stack spacing={0.5}>
        {pairs.map(([start,end],i)=>(
          <Stack key={i} direction="row" alignItems="center" spacing={0.5}>
            {[start,end].map((time,j)=>{
              const title=(labels && i===0?'':`第${i+1}组`)+(j?'结束时间':'开始时间');
              return <React.Fragment key={j}>
                {j===1 && <Box component="span">~</Box>}
                <TimeField value={time} onChange={val=>change(i*2+j,val)} format="HH:mm" disabled={disabled}
                  label={labels?title:undefined}
                  inputProps={{'aria-label':labels?title:`${labelPrefix} ${title}`}}
                  sx={{width:labels?135:60,'& .MuiInputBase-input':{p:'5px'}}} />
              </React.Fragment>;
            })}
            {!disabled && (pairs.length>1 || onClear) && (
              <Tooltip title={pairs.length>1?'删除这组时段':'恢复全天'}>
                <IconButton size="small" aria-label={pairs.length>1?`删除第${i+1}组时段`:'恢复全天'}
                  onClick={()=>pairs.length>1?onChange(value.filter((_,index)=>Math.floor(index/2)!==i)):onClear()}>
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {!disabled && i===pairs.length-1 && (
              <Tooltip title="新增时段"><IconButton size="small" aria-label="新增时段" onClick={add}><AddIcon fontSize="small" /></IconButton></Tooltip>
            )}
          </Stack>
        ))}
      </Stack>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </Box>
  );
}
